/* Module-level scroll-lock counter shared across all Modal instances.
   Two concurrent modals used to work by coincidence; three or an
   unmount-out-of-order race would leave scroll incorrectly restored
   because each instance snapshotted + restored document.body.style
   .overflow independently. Reference-count instead: first lock stores
   the prior value and applies 'hidden'; last unlock restores.

   iOS Safari ignores `body { overflow: hidden }` and keeps scrolling
   the underlying page on touch. Locking `html` as well catches the
   remaining cases. `overscroll-behavior: contain` on the body
   suppresses rubber-band scroll pass-through in WebKit when the
   modal itself has scrollable content. */

interface SavedStyles {
  bodyOverflow: string;
  htmlOverflow: string;
  bodyOverscroll: string;
}

let _lockDepth = 0;
let _saved: SavedStyles | null = null;

export function acquireScrollLock(): void {
  if (typeof document === 'undefined') return;
  if (_lockDepth === 0) {
    _saved = {
      bodyOverflow: document.body.style.overflow,
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverscroll: document.body.style.overscrollBehavior,
    };
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'contain';
  }
  _lockDepth += 1;
}

export function releaseScrollLock(): void {
  if (typeof document === 'undefined') return;
  if (_lockDepth === 0) return;
  _lockDepth -= 1;
  if (_lockDepth === 0 && _saved) {
    document.body.style.overflow = _saved.bodyOverflow;
    document.documentElement.style.overflow = _saved.htmlOverflow;
    document.body.style.overscrollBehavior = _saved.bodyOverscroll;
    _saved = null;
  }
}
